export default {
  workshop: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Punishtja dhe zejtaria',
    hero: {
      eyebrow: 'Punishtja dhe zejtaria',
      title: 'Teknologji sigurie e qëndrueshme për mjedise të vështira',
      lead: 'Pluhuri, lagështia, luhatjet e temperaturës – punishtet kërkojnë shumë. Montojmë kamera që i bëjnë ballë.',
    },
    areas: {
      title: 'Fushat e përdorimit në punishte dhe zejtari',
      lead: 'Nga zona e punishtes te oborri i jashtëm – sigurojmë veglat, makineritë dhe automjetet tuaja të vlefshme.',
      items: {
        '0': { title: 'Salla e punishtes', desc: 'Sallat e larta me makineri kanë nevojë për kamera të qëndrueshme me rezolucion të mirë – edhe në dritë të vështirë.' },
        '1': { title: 'Zona e punishtes', desc: 'Veglat, pjesët e këmbimit dhe punët në vazhdim: mbikëqyrja mbron hapësirën dhe sqaron ankesat.' },
        '2': { title: 'Zona e ngarkimit', desc: 'Ngarkimi dhe shkarkimi janë dritare për vjedhje. Kamerat dokumentojnë çdo operacion me besueshmëri.' },
        '3': { title: 'Zona e makinerive', desc: 'Prodhimi modern kërkon dokumentim të plotë të procesit – edhe mes makinerive.' },
        '4': { title: 'Oborri dhe parkimi', desc: 'Automjete, rimorkio dhe materiale – oborri ka nevojë për kamera rezistente me shikim të mirë nate.' },
        '5': { title: 'Zyra dhe administrata', desc: 'Ofertat, faturat dhe të dhënat e klientëve janë në zyrë. As këtu siguria nuk duhet lënë pas dore.' },
      },
    },
    robust: {
      eyebrow: 'Qëndrueshmëria',
      title: 'E ndërtuar për përdorim të rëndë',
      lead: 'Punishtet nuk janë sallone ekspozimi. Kamerat tona janë bërë për këto mjedise dhe zgjidhen për kushtet tuaja.',
      items: {
        '0': { title: 'Klasë e lartë mbrojtjeje', desc: 'Kutitë IP66 mbrojnë nga pluhuri, spërkatjet dhe shiu – edhe në përdorim të vazhdueshëm të jashtëm.' },
        '1': { title: 'Rezistente ndaj temperaturës dhe lagështisë', desc: 'Nga magazina e akullt te punishtja e ngrohtë: zgjedhim kamera për çdo diapazon temperature.' },
        '2': { title: 'Kuti të mbrojtura nga pluhuri', desc: 'Në mjedise me pluhur, kutitë dhe guarnicionet speciale e mbajnë optikën të pastër dhe të qartë për vite.' },
      },
    },
    maintenance: {
      eyebrow: 'Mirëmbajtja dhe kujdesi',
      title: 'Që sistemi juaj të mbetet i besueshëm',
      lead: 'Në mjedise me pluhur dhe të vështira, kujdesi përcakton jetëgjatësinë. Me SSG Care sistemi juaj mbetet gjithmonë gati.',
      list: {
        '0': 'Kontrolle të rregullta nga SSG Care – edhe jashtë garancisë',
        '1': 'Pastrim dhe kontroll vizual i kutisë dhe objektivit',
        '2': 'Përditësime firmueri dhe sigurie sipas nevojës',
        '3': 'Reagim i shpejtë ndaj defekteve',
        '4': 'Mundësi pjesësh këmbimi dhe përmirësimi për sistemin tuaj',
      },
      note: 'Shënim: ligjshmëria e mbikëqyrjes me video varet nga rasti. Ne ju këshillojmë, pa zëvendësuar këshillën ligjore.',
    },
    cta: {
      title: 'Punishtja juaj meriton një vështrim të sigurt',
      lead: 'Ju këshillojmë pa detyrim se cilat kamera i bëjnë ballë mjedisit tuaj dhe ku mbrojnë më shumë.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Zbuloni SSG Care',
    },
  },
};